import { FC } from 'react';

import { Head } from '@inertiajs/react';

const Terms: FC = () => (
    <>
        <Head title="Умови використання | CartOn" />
        <div className="container mx-auto max-w-4xl py-10">
            <div className="mb-10">
                <h1 className="mb-4 text-3xl font-bold">Умови використання</h1>
                <p className="text-lg text-muted-foreground">
                    Ласкаво просимо до CartOn! Будь ласка, уважно прочитайте ці
                    Умови використання перед користуванням нашим сервісом.
                </p>
            </div>

            <div className="prose prose-sm max-w-none space-y-4 dark:prose-invert">
                <h2 className="mt-6 mb-2 text-xl font-semibold">
                    1. Загальні положення
                </h2>
                <p>
                    Використовуючи наш веб-сайт, ви погоджуєтесь дотримуватися
                    цих Умов. Якщо ви не згодні з будь-якою частиною умов, ви не
                    можете користуватися сервісом.
                </p>

                <h2 className="mt-6 mb-2 text-xl font-semibold">
                    2. Облікові записи
                </h2>
                <p>
                    Коли ви створюєте обліковий запис у нас, ви повинні надати
                    нам інформацію, яка є точною, повною та актуальною.
                    Недотримання цієї вимоги є порушенням Умов, що може
                    призвести до негайного видалення вашого облікового запису.
                </p>

                <h2 className="mt-6 mb-2 text-xl font-semibold">
                    3. Правила маркетплейсу
                </h2>
                <ul className="list-disc space-y-1 pl-5">
                    <li>
                        Продавці надсилають товари відповідно до деталей
                        замовлення, узгоджених із покупцем. Після підтвердження
                        замовлення його склад, вартість і строки відправлення
                        можуть бути змінені за взаємною згодою продавця та
                        покупця.
                    </li>
                    <li>
                        Покупці зобов&#39;язані оплачувати замовлені товари.
                    </li>
                    <li>
                        Заборонено продавати підроблені товари або товари,
                        продаж яких заборонено законодавством України.
                    </li>
                    <li>
                        Ми залишаємо за собою право видаляти будь-який контент
                        або товари, які порушують ці правила.
                    </li>
                </ul>

                <h2 className="mt-6 mb-2 text-xl font-semibold">
                    4. Інтелектуальна власність
                </h2>
                <p>
                    Сервіс та його оригінальний контент, функції та
                    функціональність є власністю CartOn та захищені міжнародним
                    законодавством про авторське право, товарні знаки та іншими
                    законами про права власності. Всі зображення карток та назви
                    ігор належать їх відповідним власникам.
                </p>

                <h2 className="mt-6 mb-2 text-xl font-semibold">
                    5. Обмеження відповідальності
                </h2>
                <p>
                    CartOn не несе відповідальності за будь-які прямі, непрямі,
                    випадкові або побічні збитки, що виникли внаслідок
                    використання або неможливості використання сервісу. Ми є
                    платформою, що з&#39;єднує покупців і продавців, і не несемо
                    відповідальності за дії користувачів.
                </p>

                <h2 className="mt-6 mb-2 text-xl font-semibold">
                    6. Застосовне право
                </h2>
                <p>
                    Ці Умови регулюються та тлумачаться відповідно до
                    законодавства України без урахування норм колізійного права.
                </p>

                <h2 className="mt-6 mb-2 text-xl font-semibold">7. Зміни</h2>
                <p>
                    Ми залишаємо за собою право на власний розсуд змінювати або
                    замінювати ці Умови в будь-який час. Продовжуючи
                    використовувати наш сервіс після внесення цих змін, ви
                    погоджуєтесь дотримуватися переглянутих умов.
                </p>
            </div>
        </div>
    </>
);

export default Terms;
